import React from "react"
import { Link } from "react-router-dom"

import getAppConfig from "~/utils/getAppConfig"

const StripeConnectNotification = () => {
  const { venue } = getAppConfig()
  const status = venue.stripeConnectStatus || "not_connected"

  if (status === "connected") return null

  const message =
    status === "onboarding"
      ? "Finish your Stripe setup to start routing new payments directly to your Stripe account."
      : "Connect Stripe to route new payments directly to your Stripe account and simplify payout reconciliation."

  return (
    <div className="alert alert-info d-flex flex-wrap align-items-center gap-2 mb-4" role="status">
      <span>{message}</span>
      <Link className="btn btn-sm btn-outline-primary ms-auto" to="/settings/venue">
        Open Stripe Connect settings
      </Link>
    </div>
  )
}

export default StripeConnectNotification
